import { FC } from 'react';

import Section from 'components/Section';
import TwoColumn from 'components/TwoColumn';
import PriceInput from 'components/PriceInput';
import TextField from 'components/TextField';

const PackageDateEditMainPrices: FC = () => {
  return (
    <Section title="Kaina" id="dates">
      <TwoColumn
        left={
          <TextField
            component={PriceInput}
            fullWidth
            name="priceOld"
            label="Pradinė kelionės kaina"
          />
        }
        right={
          <TextField
            component={PriceInput}
            fullWidth
            disabled
            name="price"
            label="Kelionės kaina"
          />
        }
      />
    </Section>
  );
};

export default PackageDateEditMainPrices;
